export var cifBh = ["301 181", "<g fill='none'><path fill='#FFF' d='M.5.5h300v180H.5'/><path fill='#CE1126' d='M300.5.5h-226l46 18-46 18 46 18-46 18 46 18-46 18 46 18-46 18 46 18-46 18h226'/></g>"];
